import React from "react";
import styled from "styled-components";

const ConsultButton = () => {
  const handleConsultClick = () => {
    window.open("http://pf.kakao.com/_Kfxezn/chat", "_blank");
  };

  return (
    <ConsultButtonWrapper onClick={handleConsultClick}>
      <ConsultIcon src="/png/chanelTalk.png" alt="상담하기" />
    </ConsultButtonWrapper>
  );
};

const ConsultButtonWrapper = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s;
  z-index: 1000;
  padding: 0;
  overflow: hidden;

  &:hover {
    transform: scale(1.1);
  }
`;

const ConsultIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export default ConsultButton;
